<script>
  import Link from '../../utils/link.html';
  import Menu from '../../components/navigation/menu';
  import Archive from '../../components/buttons/trash';
  import Plus from '../../components/buttons/plus';
  import Loader from '../../components/ui/loader.html';
  import { onMount, afterUpdate, getContext } from "svelte";
  import { gql } from "apollo-boost";
  import {addNotification, ICONS} from '../../utils/notifications.store';
  import {UPDATE_COORDINATOR, ADD_COORDINATOR} from '../../graphql/coordinators';

  import {SPONSOR, UPDATE_SPONSOR} from '../../graphql/sponsors';

  import CoordinatorGeneral from './components/sections/sponsor.general';


  const client = getContext('apollo');
  const history = getContext('history');

   const components = {
    'general': CoordinatorGeneral,
  }

  export let match = {};
  let loading = true;
  let sponsor;
  let error;
  $: current = components[match.params.section] || components['general'];
 

  const menu = [
    {id:'general', label: 'Sponsor Details', link:`/sponsors/view/${match.params.id}`},
  ]

  async function getSponsor() {
    try {
      const { data } = await client.query({
        query: SPONSOR,
        variables: { id: match.params.id }
      });

      sponsor= data.sponsor;
      loading = false;
    } catch (e) {
      loading = false;
      error = e;
    }
  }

  onMount(getSponsor);

  async function commitArchive() {
    try {
      await client.mutate({mutation: UPDATE_SPONSOR, variables: {input: {
        id: sponsor.id,
        archived: true
      }}})
      

      addNotification({
        message:`Archived ${sponsor.name}`, 
        icon: ICONS.SUCCESS,
        time: 3000
      })

      history.push('/sponsors');

    } catch (e) {
      addNotification({
        message:`There was a problem archiving ${sponsor.name}`, 
        icon: ICONS.ERROR,
        time: 3000
      })
    }
  }

  function archive() {


    
    addNotification({
      message:`Are you sure you want to archive ${sponsor.name}? They will no longer show up in the admin, but will remain assigned to existing programs and events.`, 
      icon: ICONS.CONFIRM,
      confirm: commitArchive
    })
  }
</script>

{#if loading}
  <Loader />
{/if}

{#if !loading}
  <div class="grid-x grid-margin-x">
    <div class="cell small-12 medium-6">
      <h1>{sponsor.name}</h1>
    </div>
    <div class="cell small-12 medium-6 text-right">
      <Archive on:click={archive} label={'ARCHIVE SPONSOR'} />
    </div>
  </div>
  <div class="grid-x grid-margin-x">
    <div class="cell small-12 medium-12">
      <!--<Menu active={match.params.section || 'general'} items={menu} />-->
    </div>
  </div>

  <svelte:component this={current} bind:value={sponsor} id={match.params.id} />
{/if}

